import React from 'react'
import RefundComp from '../Components/refundsection/RefundComp'

function Refund() {
  return (
    <>
      <RefundComp />
    </>
  )
}

export default Refund